import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import style from './input.scss';
import omit from 'lodash/omit';

@CSSModules(style, { allowMultiple: true })
export default class Input extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    formFieldName: PropTypes.string,
    getFormValue: PropTypes.func
  };

  state = {
    val: this.props.value || (this.context.getFormValue && this.context.getFormValue(this.name))
  }

  handleChange(e) {
    this.handleElementChange(e.target);
  }

  handleElementChange(el, firstTime = false) {
    const value = el.type === 'file' ? el.files[0] : el.value;

    if (this.context.onChange) {
      this.context.onChange(this.name, value);
    }

    if (!firstTime && this.props.onChange) this.props.onChange(value);
  }

  componentDidMount() {
    this.handleElementChange(this.refs.element, true);

    if (this.props.onLoad) this.props.onLoad(this);
  }

  componentWillReceiveProps() {
    this.setState({ val: (this.context.getFormValue && this.context.getFormValue(this.name)) });
  }

  click() {
    this.refs.element.click();
  }

  get name() {
    return this.props.name || this.context.formFieldName;
  }

  _value(props) {
    return this.state.val
  }

  get value() {
    return this._value(this.props);
  }

  render() {
    const { type, rows, size, forceOnChange, disabled } = this.props;
    let _componentName, styleName;

    if (rows) {
      _componentName = 'textarea';
      styleName = 'root textarea';
    } else {
      _componentName = 'input';
      styleName = 'root';
    }

    if (size) styleName += ` size-${size}`;

    return (
      <_componentName
        ref="element"
        styleName={`${styleName} ${process.muhimma.indexOf(process.target[0]) !== -1 ? 'muhimma' : ''} ${disabled ? 'disabled' : ''}`}
        className="Input"
        value={type === 'file' ? undefined : this.value === null || this.value === undefined ? '' : this.value}
        onBlur={e => !forceOnChange ? this.handleChange(e) : () => {}}
        onChange={e => type === 'file' || forceOnChange ? this.handleChange(e): this.setState({ val: e.target.value })}
        {...omit(this.props, 'onChange', 'styles', 'forceOnChange')}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/input.js